const detect = (): { isMac: boolean } => {
  if (typeof navigator === "undefined") return { isMac: false };
  const ua = navigator.userAgent;
  return { isMac: /Mac|iPhone|iPad|iPod/i.test(ua) };
};

const { isMac } = detect();

export const MOD_KEY: string = isMac ? "⌘" : "Ctrl";
export const IS_MAC: boolean = isMac;
